export default __webpack_public_path__ + "static/media/gallery_09.785e98da.jpg";